import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import localForage from 'localforage'
import { HeaderItem } from 'components/misc'
import { NotificationCentreModal } from 'components/modals'
import { apiDashboard } from 'helpers/decorators/api'
import MODALS from 'constants/layout/modals'
import { modal } from 'helpers/decorators'
import styles from './notifications-icon.styl'

const storeKey = 'dofe-fo/notifications/timestamp'

@apiDashboard.apiNotification({ loadCount: true })
@modal.trigger()
class NotificationsIcon extends Component {
  static propTypes = {
    menuItem: PropTypes.bool.isRequired,
    onLoadNotifications: PropTypes.func.isRequired,
    onMarkAsRead: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
    notificationsData: PropTypes.object,
    notificationsLoading: PropTypes.bool,
    notificationsCount: PropTypes.object,
    onlyTrigger: PropTypes.bool
  }

  static defaultProps = {
    menuItem: false
  }

  state = {
    storeTimestamp: null,
    canBeShowed: true
  }

  componentDidMount() {
    this.updateStoreTimestamp()
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.storeTimestamp !==
      get(nextProps.notificationsCount, 'lastTimestamp')
    ) {
        this.updateStoreTimestamp()
    }

    if (get(nextProps.notificationsCount, 'count') > 0 && this.state.canBeShowed) {
      this.saveTimestamp()
      this.setState({ canBeShowed: false })
    }
  }

  updateStoreTimestamp = () =>
    localForage
      .getItem(storeKey)
      .then(storeTimestamp => this.setState({ storeTimestamp }))
      .catch(console.error)

  saveTimestamp = () => {
    const { notificationsCount, onLoadNotifications } = this.props

    onLoadNotifications()
    this.handleOpenNotifications()
    localForage
      .setItem(storeKey, get(notificationsCount, 'lastTimestamp'))
      .catch(console.error)
  }

  handleOpenNotifications = () => {
    this.props.onOpen(MODALS.NOTIFICATION_CENTRE, null, null)
  }

  render() {
    const {
      notificationsCount,
      notificationsData,
      notificationsLoading,
      menuItem,
      onlyTrigger,
      onMarkAsRead
    } = this.props

    const lastTimestamp = get(notificationsCount, 'lastTimestamp')

    const count = get(notificationsCount, 'count')

    const showNumber = this.state.storeTimestamp !== lastTimestamp && Boolean(count)

    return (
      <div className={styles.wrap}>
        {menuItem ? (
          <HeaderItem
            ico="notifications"
            caption="Notifications"
            captionKey="label.notifications"
            onClick={this.saveTimestamp}
            rightItem={
              showNumber && (
                <span className={`${styles.count} ${styles.center}`}>
                  {count}
                </span>
              )
            }
          />
        ) : (
          <div className={styles.inner} onClick={this.saveTimestamp}>
            <i className={`ico ico--notifications ${styles.ico}`} />
            {showNumber && <span className={styles.count}>{count}</span>}
          </div>
        )}
        {!onlyTrigger && (
          <NotificationCentreModal
            notificationsData={notificationsData}
            modalId={MODALS.NOTIFICATION_CENTRE}
            loading={notificationsLoading}
            onMarkAsRead={onMarkAsRead}
          />
        )}
      </div>
    )
  }
}

export default NotificationsIcon
